/// <amd-module name="Widgets/Burndown/BurndownWidgetComponents/BurndownDataContract" />
import { FieldFilter } from "./BurndownSettings";

/** Provides a breakdown of work effort, optionally per date*/
export interface WorkItemEffort {
    WorkItemType: string;
    Date: string;
    StateCategory: string;
    AggregatedEffort: number;
    State: string
}

/**
 * Wire and Client type representing aggregate work effort as of right now.
 */
export interface CurrentWorkItemAggregateEffort {
    StateCategory: string;
    AggregatedEffort: number;
    State: string;
}

/** Client-side type representating work item formatting for use by query generators
 * Note: Possible field types are at https://www.visualstudio.com/en-us/docs/work/reference/field-definition-element-reference#attributes-and-elements
 * The fields match analytics naming
 */
export interface WorkItemFieldDescriptor {
    /** Name of the field */
    FieldName: string;

    /** Type of the field */
    FieldType: string;

    /** Reference name of the field in VSTS  */
    FieldReferenceName: string;

    /** Should we use quotes to pass the value to Analytics, or pass value as-is */
    /** This value is calculated client-side. */
    UseQuotes: boolean;

    /** When making an analytics query, this is the path to use. */
    /** This value is calculated client-side. */
    AnalyticsFilterName: string;

    /** Function to figure out the value to query by from a FieldFilter */
    /** This function is calculated client-side. */
    GetAnalyticsQueryValueFunc(filter: FieldFilter): string;
}

/**
 * Module for constants regarding WorkItemStateCategories
 */
export enum WorkItemStateCategoryNames {
    Proposed = "Proposed",
    InProgress = "InProgress",
    Resolved = "Resolved",
    Completed = "Completed",
    Removed = "Removed",
    DefaultWorkItemStateCategory = "InProgress"
}

/**
 * Represents information about a WorkItemStateCategory
 */
export interface IWorkItemStateCategory {
    /**
     * Reference Name
     */
    refName: string;
    /**
     * Display Name
     */
    displayName: string;
    /**
     * Order with respect to other WorkItemStateCategories
     */
    order: number;
    /**
     * Default Color for WorkItemStateCategory
     */
    defaultColor: string;
    toString: () => string;
}

/**
 * Information for each WorkItemStateCategory
 */
export declare const WorkItemStateCategoryData: { [key: string]: IWorkItemStateCategory };

/**
 * Describes the nature of filtering by work item type to perform. By presence in an agile board level, or directly by board-agnostic work item type.
 */
export enum WorkItemTypeFilterMode {
    /** When using work item type, the settings value is stored as a string. */
    WorkItemType,

    /** When using backlog category, the settings value is stored as a string. */
    BacklogCategory
}
